// libs
import dayjs from 'dayjs';
// stores
import { DateRangeEnum } from '@/stores/defs/metrics';
export const getStartAndEndDates = (dateRange) => {
    if (dateRange === DateRangeEnum.LAST_WEEK) {
        return {
            startDate: dayjs().subtract(7, 'day').toDate(),
            endDate: dayjs().subtract(1, 'day').toDate(),
        };
    }
    else {
        return {
            startDate: dayjs().subtract(1, 'month').toDate(),
            endDate: dayjs().subtract(1, 'day').toDate(),
        };
    }
};
/**
 * This function is used to disable dates in the date picker
 * @param dateToCheck - date to check if it should be disabled
 * @param referenceDate - start date, if already selected, else undefined
 * @description
 * 1. if referenceDate is not provided, ie for the startDate picker, then
 * disable dates before 3 months ago and after yesterday
 * 2. if referenceDate is provided, ie for the endDate picker, then
 * disable dates before the reference date and after yesterday
 */
export const matchDisabledDays = (dateToCheck, referenceDate) => {
    if (!referenceDate) {
        return (dayjs(dateToCheck).isBefore(dayjs().subtract(3, 'months')) ||
            dayjs(dateToCheck).isAfter(dayjs().subtract(1, 'day')));
    }
    return (dayjs(dateToCheck).isBefore(dayjs(referenceDate)) ||
        dayjs(dateToCheck).isAfter(dayjs().subtract(1, 'day')));
};
export const validateRange = (start, end) => dayjs(end).isAfter(dayjs(start));
